// extracted by mini-css-extract-plugin
export default {"leftbarWidthInt":"54","leftbarWidth":"54px","appbarHeightInt":"54","appbarHeight":"54px","segmentIcon":"SegmentMarker__segmentIcon___EatUP","icon":"SegmentMarker__icon___rfmgh"};